import { Component, OnInit } from "@angular/core";
import { getPortalUrl, isClientSideExecution } from "@app/core/utils";
import { AuthenticationService } from "../authentication.service";

@Component({
    selector: "app-confirm-login",
    templateUrl: "./confirm.component.html",
    styleUrls: ["./confirm.component.scss"],
    standalone: false,
})
export class ConfirmComponent implements OnInit {
    invalidToken: boolean = false;
    year: string = new Date().getFullYear().toString();

    constructor(public authenticationService: AuthenticationService) {}

    ngOnInit(): void {
        if (!this.authenticationService.identifier.value) {
            if (isClientSideExecution()) {
                window.location.href = getPortalUrl();
            }
        }
        this.authenticationService.loading.next(false);
    }

    verify(evt) {
        this.authenticationService.loading.next(true);
        this.authenticationService.confirmSession(evt);
    }

    updateError(evt) {
        this.authenticationService.invalidConfirmationToken.next(evt);
    }

    resendCode() {
        this.authenticationService.resendEmailWithOTP();
    }

    updateRememberDevice(evt) {
        this.authenticationService.rememberDevice.next(evt.checked);
    }
}
